import React from "react";
import IntegratedExternalAgentApp from "../../components/IntegratedExternalAgentApp";

export default function IntegratedBankingApp() {
  return <IntegratedExternalAgentApp agent="banking" title="AzentMart AI Banking Agent" />;
}
